import './App.css';
import './style.css';
import {Routes,Route} from 'react-router-dom';
import Navbar from './Components/Navbar';
import Feed from './Components/Feed';
import VideoDetails from './Components/VideoDetails';
import ChannelDetails from './Components/ChannelDetails';
import SearchFeed from './Components/SearchFeed';
import React,{useState} from 'react'
// import { faHouse,faCode,faMusic,faSchool,faPodcast,faFilm,faGamepad,faTv,faBaseball,faShirt,faMasksTheater,faDumbbell, faBitcoinSign} from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


// function getWindowSize() {
//   const {innerWidth, innerHeight} = window;
//   return {innerWidth, innerHeight};
// }


function App() {
  // const [selectedCategory,setSelectedCategory] = useState('New');
  const [showSidebar, setShowSidebar] = useState(false);
  const [toShow, setToShow] = useState(false);

  const handleClick = () => {
    setShowSidebar(!showSidebar);
    // alert("Click to toggle");
  }

  const updateToShow = ()=>{
    setToShow(true);
  }
  const HideToShow = ()=>{
    setToShow(false);
  }


  // const [windowSize, setWindowSize] = useState(getWindowSize());


  // const categories = [
  //   { name: 'New', icon: faHouse, },
  //   { name: 'Coding', icon: faCode },
  //   { name: 'ReactJS', icon: faCode },
  //   { name: 'NextJS', icon: faCode },
  //   { name: 'Music', icon: faMusic },
  //   { name: 'Education', icon: faSchool, },
  //   { name: 'Podcast', icon: faPodcast },
  //   { name: 'Movie', icon: faFilm },
  //   { name: 'Gaming', icon: faGamepad },
  //   { name: 'Live', icon:  faTv},
  //   { name: 'Sport', icon:  faBaseball},
  //   { name: 'Fashion', icon:  faShirt},
  //   { name: 'Comedy', icon:faMasksTheater},
  //   { name: 'Gym', icon:  faDumbbell},
  //   { name: 'Crypto', icon: faBitcoinSign },
  // ];
  
  return (
    <div className="App">
      <Navbar setSidebar={handleClick} toShow={toShow}/>
     
      <Routes >
        <Route path="/" element={<Feed showSidebar={showSidebar} updateToShow={updateToShow}/>} />
        <Route path="/video/:videoId" element={<VideoDetails HideToShow={HideToShow}/>} />
        <Route path="/channel/:channelId" element={<ChannelDetails HideToShow={HideToShow}/>} />
        <Route path="/search/:searchId" element ={<SearchFeed HideToShow={HideToShow}/>} />
      </Routes>

    </div>
  );
}

export default App;
